import { event, GtagEvent } from "./event";
export interface LevelEnd extends GtagEvent {
    level_name?:string;
    success?:boolean;
}
export const level_end = ($_?:LevelEnd) => event('level_end',$_);